import { Button as AntButton, Modal } from "antd";
import moment from "moment";
import { FC, useEffect } from "react";
import { useTranslation } from 'react-i18next';
import { deleteHoliday } from "../../../../api/holidays.api";
import useAxios from "../../../../hooks/useAxios";
import useNotification from "../../../../hooks/useNotification";
import ErrorResponse from "../../../ErrorResponse";
import Loader from "../../../Loader";

interface IProps {
  visible: boolean;
  setVisible: (visible: boolean) => void;
  event: any;
  setEvent: (event: any) => void;
  doGetHolidays: () => void;
}

const DeleteHolidayModal: FC<IProps> = ({
  visible,
  setVisible,
  event,
  setEvent,
  doGetHolidays,
}) => {
  const { t } = useTranslation();
  const { successNotification } = useNotification();
  const { data: deleteData, isLoading: deleteIsLoading, error: deleteError, execute: deleteExecute } = useAxios();

  useEffect(() => {
    if (deleteData && !deleteIsLoading) {
      doGetHolidays();
      setEvent(null);
      setVisible(false);
      successNotification(t('common.message.delete'));
    }
  }, [deleteData, deleteIsLoading]);

  const onDelete = async () => {
    deleteExecute(deleteHoliday(event.id));
  }

  return (
    <>
      {deleteIsLoading && <Loader />}
      <ErrorResponse error={deleteError} />
      <Modal
        title={t('program.holiday.title2')}
        visible={visible}
        onCancel={() => setVisible(false)}
        footer={[
          <div className='comm-btn__area justify-content-center'>
            <AntButton
              key="submit"
              className='btn-basic pink'
              onClick={onDelete}
            >
              {t('common.button.confirm')}
            </AntButton>
            <AntButton
              key="cancel"
              className='btn-basic gray'
              onClick={() => setVisible(false)}
            >
              {t('common.button.cancel')}
            </AntButton>
          </div>
        ]}
      >
        <div className="form-group row mx-5">
          <label
            htmlFor="inputEmail3"
            className="col-2 col-form-label text-right"
          >
            {t('program.holiday.column2')}
          </label>
          <div className="col-10">
            <input
              type="text"
              className="form-control input-text"
              value={event ? moment(event.start).format('YYYY-MM-DD') : ''}
              readOnly
            />
          </div>
        </div>
        <div className="form-group row mx-5">
          <label
            htmlFor="inputEmail3"
            className="col-2 col-form-label text-right"
          >
            {t('program.holiday.column3')}
          </label>
          <div className="col-10">
            <input
              type="text"
              className="form-control input-text"
              value={event?.title}
              readOnly
            />
          </div>
        </div>
        <div className="text-center">
          {t('program.holiday.text6')}
        </div>
      </Modal>
    </>
  );
};

export default DeleteHolidayModal;
